// extracted by mini-css-extract-plugin
export default {"collaboratorCard":"CollaboratorCard_collaboratorCard__PNnGc","alt":"CollaboratorCard_alt__U8xqI","header":"CollaboratorCard_header__TxE2L","title":"CollaboratorCard_title__7pf2G"};